// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"645":"css/app.6940","5153":"css/admin-app.6940"}[chunkId] + ".css";
};